<template>
  <div>
    <div class="container">
      <div class="sort-list">
        <div class="row text-center">
          <div class="col-12 tit-sort">
            <h3>在家就能学编程</h3>
          </div>
          <div class="col-12 subtit-sort">缩减时间成本，打造高效学习</div>
        </div>
        <div class="row">
          <div class="col-6 xbc-txt">
            <div class="row align-items-center mar-xbctxt">
              <div>
                <i class="fa fa-coffee fa-2x"></i>
              </div>
              <div>
                在家就能学，摆脱地域限制
                <br />省去接送烦恼，上课时间更自由
              </div>
            </div>
            <div class="row align-items-center mar-xbctxt">
              <div>
                <i class="fa fa-cubes fa-2x"></i>
              </div>
              <div>
                采用先进网络技术打造在线学习平台,实现在家学编程
                <br />完善的课程设置及课后作业体系,保证孩子学习效果
              </div>
            </div>
          </div>
          <div class="col-6 text-center">
            <img src="@/assets/images/bianc.png" />
          </div>
        </div>
      </div>
    </div>

    <div class="container-fuid bg-1 border">
      <div class="sort-list">
        <div class="row text-center">
          <div class="col-12 tit-sort">
            <h3>为什么这么多人学编程</h3>
          </div>
          <div class="col-12 subtit-sort">抓住逻辑训练黄金期，构建面向未来思维</div>
        </div>
        <div class="container">
          <div class="row align-items-center mar-bt1">
            <i class="fa fa-database text-info"></i>&nbsp;&nbsp;人工智能时代，让孩子先人一步，赢在AI
          </div>
          <div class="row text-center mar-bt1">
            <div class="col-3" v-for="(item,index) in bchclist" :key="index">
              <div :class="['card-style',bordercolor2[index]]">
                <img class="img-suit" :src="require('@/assets/images/'+item.pic)" />
                <p>{{item.title}}</p>
                <p class="font-2 text-left padd-2">{{item.intro}}</p>
              </div>
            </div>
            
          </div>

          <div class="row align-items-center mar-tp1 mar-bt1">
            <i class="fa fa-database text-info"></i>&nbsp;&nbsp;孩子参加比赛赢得荣誉，为升学添砖加瓦
          </div>
          <div class="row text-center">
            <div class="col-4" v-for="(item,index) in sslist" :key="index">
              <div :class="['card-style', bordercolor[index]]">
                <img class="img-suit" :src="require('@/assets/images/'+item.pic)" />
                <p>{{item.title}}</p>
                <p class="font-2 text-left padd-2">{{item.intro}}</p>
              </div>
            </div>            

          </div>
        </div>
      </div>
    </div>

    <div class="container text-center">
      <div class="sort-list">
        <div class="row">
          <div class="col-12 tit-sort">
            <h3>课程介绍</h3>
          </div>
          <div class="col-12 subtit-sort">适合全年龄段孩子的完备的课程体系</div>
        </div>
        <div class="row">
          <div class="col-3" v-for="(item,index) in kcjs" :key="index">
            <img class="img-suit3"  :src="require('@/assets/images/'+item.pic)" />
            <p>{{item.title}}</p><p v-if="index<2"><a :href="item.demourl" target="_blank">免费体验课</a></p>
          </div>          
        </div>
        <div class="row tixitu">
          <div class="col-3"></div>
          <div class="col-1 big" v-for="(item,index) in kctx" :key="index">
            <div class="small">
              <p :class="{'active':index==0}">{{item.title}}</p>
              <img :src="require('@/assets/images/'+item.pic)" />
            </div>
          </div>          
          <div class="col-3"></div>
        </div>

        <div class="row">
          <div class="col-3"></div>
          <div class="col-6 tixitu-detail text-center">
            <p v-for="(item,index) in kctx" :key="index">
              <span>{{item.contsp}}--</span>{{item.cont}}
            </p>            
          </div>
        </div>

      </div>
    </div>

    <div class="container-fuid text-center bg-1 border">
      <div class="sort-list">
        <div class="row">
          <div class="col-12 tit-sort">
            <h3>学员作品</h3>
          </div>
          <div class="col-12 subtit-sort">学员的真实案例作品展示</div>
        </div>
        <div class="row">
          <div class="col-1"></div>
          <div class="col-2 zuopin-list" v-for="(item,index) in zuopininfo" :key="index">
            <a :id="'v_'+index" @click="playvid(index)">
              <img class="img-play" src="@/assets/images/play.png" />
              <img class="img-thumbnail img-cover" :src="require('@/assets/images/'+item.pic)" />
              <p>{{item.title}}</p>
            </a>
          </div>          
          <div class="col-1"></div>
        </div>
      </div>
    </div>

    <!--模态框-->
    <div id="video-lg" class="modal fade" >
        <div class="modal-dialog modal-lg" >
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" >&times;</button>
                </div>
                <div class="modal-body">
                    <div class="embed-responsive embed-responsive-16by9" id="popup-video">
                        <video id="inner-video" class="embed-responsive-item" controls preload="metadata" autoplay></video>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>   
    
 

export default {
    data(){
        return{
            bordercolor:['border-info','border-success','border-warning','border-danger'],
            bordercolor2:['border-danger','border-warning','border-success','border-info'],
            zuopininfo:[
                {title:'我来画花园',pic:'zuopin1.jpg',vid:'zuopin1.mp4'},
                {title:'大鱼吃小鱼',pic:'zuopin2.jpg',vid:'zuopin2.mp4'},
                {title:'飞机大战',pic:'zuopin3.jpg',vid:'zuopin3.mp4'},
                {title:'我来踢足球',pic:'zuopin4.jpg',vid:'zuopin4.mp4'},
                {title:'美丽的图案',pic:'zuopin5.jpg',vid:'zuopin5.mp4'},
            ],
            kctx:[
                {title:'scratch基础',pic:'1.png',contsp:'Scratch基础编程',cont:'掌握基本编程思想，培养逻辑思维能力和解决问题能力，能独立设计制作简单的小作品。'},
                {title:'Scratch高级',pic:'2.png',contsp:'Scratch高级编程',cont:'掌握高级编程思维，理解综合逻辑概念，独立设计制作较复杂的作品。'},
                {title:'Python趣味',pic:'3.png',contsp:'Python趣味编程',cont:'了解Python语言，初步认识代码编程的含义，能独立设计编写有趣的作品。'},
                {title:'Python应用',pic:'4.png',contsp:'Python应用编程',cont:'掌握Python全部语法，熟悉面向对象编程思维，理解机器学习及AI算法，能设计开发大型应用项目。'},
                {title:'网站设计开发',pic:'5.png',contsp:'网站设计开发',cont:'学会项目分析，掌握常用前后端开发框架的使用，能独立设计开发大型网站项目。'},
                {title:'编程竞赛培训',pic:'6.png',contsp:'编程竞赛培训',cont:'掌握高级算法，能使用Scratch、Python及C++语言参加各类编程竞赛。'},
            ],
            kcjs:[
                {title:'Scratch编程',pic:'scratch.png',demourl:'https://ke.qq.com/course/470384'},
                {title:'Python编程',pic:'python.png',demourl:'https://ke.qq.com/course/473678'},
                {title:'网站设计',pic:'webdesign.png',demourl:''},
                {title:'赛事培训',pic:'noip.png',demourl:''},
            ],
            sslist:[
                {title:'全国青少年软件编程等级考试',pic:'djk.jpg',intro:'中国电子学会主办，面向中小学生，分为图形化级（Scratch 1-4级）和代码级（C/C++ 1-10级 Python 1-6级）'},
                {title:'谷歌全国中小学生计算思维编程挑战赛',pic:'guge.jpg',intro:'旨在鼓励青少年在动手实践的过程中，不断培养和锻炼计算思维能力，把创新的点子动手实现，面向全国中小学生'},
                {title:'全国青少年信息学奥林匹克联赛',pic:'noip2.jpg',intro:'NOIP 每年由中国计算机学会统一组织，主要面向初高中学生，分为普及组和提高组'},               
            ],
            bchclist:[
                {title:'培养逻辑思维能力',pic:'logic.jpg',intro:'编程可以很好的培养孩子的逻辑思维能力，锻炼孩子独立思考和分析问题的能力'},
                {title:'构建面向未来的创新能力',pic:'innove.jpg',intro:'编程可以让孩子站在时代最前沿，具备未来社会所需的核心创造力'},
                {title:'改掉拖延，学习更主动',pic:'delay.jpg',intro:'编程可以培养孩子规划能力，让做事有计划，不拖延，培养良好学习习惯'},
                {title:'全面提高各科学习成绩',pic:'grade.jpg',intro:'逻辑思维和解决问题能力在学科学习中非常重要，可很大程度提高孩子各科学习成绩'},
            ]
        }
    },
    
    methods:{
       playvid(index){          
           $("#inner-video").attr('src', require('@/assets/images/'+this.zuopininfo[index].vid));
           $("#video-lg").modal({
               backdrop: "static",
               show:true
           });        
       } ,
       showsty(){
         $(".tixitu-detail p").eq(0).show();
         $(".tixitu img").mouseover(function() {
             $(".tixitu p").removeClass("active");
             var index = $(this).index(".tixitu img");
             $(".tixitu p").eq(index).addClass("active");
             $(".tixitu-detail p").eq(index).show().siblings().hide();
          }); 
       }
    },
    mounted:function(){
        this.showsty();

         $("#video-lg").on('hidden.bs.modal', function () {
             $("#inner-video").trigger('pause');
         });
         $(".close").on('click',function(){
             $("#inner-video").removeAttr("src");
             document.getElementById("inner-video").pause();
         });  
    }
};
</script>
<style scoped>
.xbc-txt {
  padding-left: 100px;
  text-align: left;
}
.mar-xbctxt {
  margin: 30px 0;
}
.mar-xbctxt i {
  padding-right: 10px;
  color: maroon;
}

.img-suit3{
    width:50%;
    height:auto;
}

.tixitu {
  margin-top: 100px;
  height: 250px;
}
.tixitu .big {
  width: 100%;
  height: 210px;
  position: relative;
}
.tixitu .small {
  width: 100%;
  position: absolute;
  bottom: 0;
}
.tixitu .small p {
  color: #787676;
}
.tixitu .small p.active {
  color: #48b1e7;
}
.tixitu .small img {
  width: 99%;
}
.tixitu-detail p {
  font-size: 16px;
  display: none;
}
.tixitu-detail p span {
  color: coral;
}

.zuopin-list:hover .img-cover {
  opacity: 0.7;
}

.img-play {
  width: 35%;
  position: absolute;
  margin-top: 18%;
  margin-left: 22%;
  z-index: 10;
  display: none;
}

.zuopin-list:hover .img-play {
  display: block;
}
</style>